import React from 'react';
import { useApplicationContext } from '@css-xp/base';
import {
  ADVOCATE_ACCESS_TYPE_TO_RESOURCE_TYPE_MAP,
  ADVOCATE_ACCESS_TYPE_TO_RESOURCE_TYPE_MAP_TYPE,
  ADVOCATE_ACCESS_TYPE,
  ADVOCATE_RESOURCE_TYPE,
} from '../advocate-pemissions';

export const useAdvocateAccessControl = ({
  accesses = ADVOCATE_ACCESS_TYPE_TO_RESOURCE_TYPE_MAP,
  accessType,
  resource,
}: {
  accesses?: ADVOCATE_ACCESS_TYPE_TO_RESOURCE_TYPE_MAP_TYPE;
  accessType: ADVOCATE_ACCESS_TYPE;
  resource: ADVOCATE_RESOURCE_TYPE;
}) => {
  const context = useApplicationContext();
  const isCustomerAdvocate = context?.isCustomerAdvocate;

  // If user is not a customer advocate, we don't need to check for advocate access
  if (!isCustomerAdvocate) {
    return true;
  }

  // If user is a customer advocate, we need to check if they have access to the resource
  return isCustomerAdvocate && accesses[accessType]?.includes(resource);
};
